(() => {
  function initialize(root) {
    if (root.dataset.helpReady) return;
    root.dataset.helpReady = 'true';
    const search = root.querySelector('[data-faq-search]');
    if (search) {
      const items = [...root.querySelectorAll('[data-faq-item]')];
      const categories = [...root.querySelectorAll('[data-faq-category]')];
      const clear = root.querySelector('[data-search-clear]');
      const count = root.querySelector('[data-faq-count]');
      let category = 'all';
      const normalize = (text) => text.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
      const searchable = new Map(items.map(item => [item, normalize(item.textContent)]));
      const filter = () => {
        const terms = normalize(search.value).trim().split(/\s+/).filter(Boolean);
        let visible = 0;
        items.forEach(item => {
          const matches = (category === 'all' || category === item.dataset.category) && terms.every(term => searchable.get(item).includes(term));
          item.hidden = !matches;
          if (matches) visible++;
        });
        count.textContent = `${visible} ${visible === 1 ? 'question' : 'questions'}`;
        root.querySelector('[data-faq-empty]').hidden = visible !== 0;
        clear.hidden = search.value.length === 0;
      };
      root.querySelectorAll('[data-search-tools]').forEach(el => { el.hidden = false; });
      search.addEventListener('input', filter);
      clear.addEventListener('click', () => { search.value = ''; filter(); search.focus(); });
      categories.forEach(button => button.addEventListener('click', () => {
        category = button.dataset.faqCategory;
        categories.forEach(option => option.setAttribute('aria-pressed', String(option === button)));
        filter();
      }));
      root.querySelector('[data-faq-reset]').addEventListener('click', () => {
        search.value = '';
        category = 'all';
        categories.forEach(option => option.setAttribute('aria-pressed', String(option.dataset.faqCategory === 'all')));
        filter();
        search.focus();
      });
      filter();
    }
    const topic = root.querySelector('[data-contact-topic]');
    if (topic) {
      const selectTopic = () => {
        if (location.hash === '#order-help') topic.value = 'Order and delivery';
        if (location.hash === '#return-help') topic.value = 'Return or damaged item';
      };
      selectTopic();
      window.addEventListener('hashchange', selectTopic);
    }
  }
  document.querySelectorAll('[data-help-center]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-help-center]').forEach(initialize));
})();
